import React from 'react';

import { nanoid } from 'nanoid';
import PropTypes from 'prop-types';

import { AreaInput } from '~/components/inputs';

import { Container } from './styles';

function Simple({ label, id = `area${nanoid()}`, ...props }) {
  return (
    <Container>
      <label htmlFor={id}>{label}</label>
      <AreaInput id={id} {...props} />
    </Container>
  );
}

Simple.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default Simple;
